import type {
  BookingCancellationPreviewResponse,
  BookingCancellationRefundPolicy,
  CreateBookingCancellationRequest,
} from '@/shared/api';

/**
 * Was der Dialog sendet. Ein offenes Storno wird genau so fortgesetzt, wie es begonnen wurde: eine
 * neue Id lehnt der Server ab, solange es offen ist, und eine andere Entscheidung ebenso — auch wenn
 * die Vorschau die Zahlung inzwischen als erstattet und damit ohne Entscheidung zeigt.
 */
export function cancellationRequest(
  preview: BookingCancellationPreviewResponse,
  decision: BookingCancellationRefundPolicy | undefined,
  freshOperationId: string,
): CreateBookingCancellationRequest {
  const unfinished = preview.unfinishedOperation;
  if (unfinished) {
    return {
      operationId: unfinished.operationId,
      refundPolicy: unfinished.refundPolicy,
      reason: unfinished.reason,
    };
  }
  return {
    operationId: freshOperationId,
    refundPolicy: preview.requiresRefundDecision ? (decision ?? null) : null,
    reason: null,
  };
}
